import request from '@/utils/request'

// 货主列表
export const owner_list=(data)=>{
  return request({
    url: '/erp-pos/base-supplier/list',
    method: 'post',
    data
  })
}

// 货主新增编辑
export const owner_update=(data)=>{
  return request({
    url: '/erp/base-supplier/create',
    method: 'post',
    data
  })
}

// 货主分配编号 
export const owner_sn=(data)=>{
  return request({
    url: '/erp/base-supplier/supplier-sn',
    method: 'post',
    data
  })
}

// 货主批次列表
export const ownerBatch_list=(data)=>{
  return request({
    url: '/erp/base-goods-batch/index',
    method: 'get',
    data
  })
}

// 货主批次详情
export const ownerBatch_detail=(data)=>{
  return request({
    url: '/erp-pos/base-goods-batch/detail',
    method: 'get',
    data
  })
}